import { useQuery } from '@apollo/client';
import { GetPublicApiPermissionsResponse } from '@provision/entity-types';
import { GET_PUBLIC_API_PERMISSIONS_QUERY } from 'src/graphql/entities/public-api-permissions/public-api-permissions.operations';
import { useNotifications } from 'src/utils/hooks';

export interface GetPublicApiPermissionsQuery {
  getPublicApiPermissions: GetPublicApiPermissionsResponse;
}

export const usePublicApiPermissions = () => {
  const { showErrorAlert } = useNotifications();

  const { data, loading } = useQuery<GetPublicApiPermissionsQuery>(
    GET_PUBLIC_API_PERMISSIONS_QUERY,
    {
      fetchPolicy: 'cache-first',
      onError: (error) => {
        console.error(error);
        showErrorAlert('Failed to load API permissions, please try again');
      },
    },
  );

  return {
    permissions: data?.getPublicApiPermissions.items,
    isLoading: loading,
  };
};
